<template>
  <div class="row m-0">
    <div class="col-12">
      <v-tabs
        v-model="tab"
        hide-slider
      >
        <v-tab
          v-for="navTab in tabs"
          :key="navTab.href"
          :disabled="navTab.disabled"
          :href="navTab.href"
          class="tab-button"
          active-class="tab-active"
          v-text="navTab.title"
        ></v-tab>
      </v-tabs>
    </div>
    <div class="col-12 p-2">
      <v-tabs-items v-model="tab">
        <v-tab-item
          v-if="tab == 'tab-1'"
          value="tab-1"
        >
          <partners-tab :request-object-key="requestObjectKey"></partners-tab>
        </v-tab-item>
        <v-tab-item
          v-if="tab == 'tab-2'"
          value="tab-2"
        >
          <branches-tab :request-object-key="requestObjectKey"></branches-tab>
        </v-tab-item>
        <v-tab-item
          v-if="tab == 'tab-3'"
          value="tab-3"
        >
          <bankrupt-debts-tab :request-object-key="requestObjectKey"></bankrupt-debts-tab>
        </v-tab-item>
        <v-tab-item
          v-if="tab == 'tab-4'"
          value="tab-4"
        >
          <bankrupt-due-rights-tab :request-object-key="requestObjectKey"></bankrupt-due-rights-tab>
        </v-tab-item>
        <v-tab-item
          v-if="tab == 'tab-5'"
          value="tab-5"
        >
          <debtor-assets-tab :request-object-key="requestObjectKey"></debtor-assets-tab>
        </v-tab-item>
        <v-tab-item
          v-if="tab == 'tab-6'"
          value="tab-6"
        >
          <debtor-employees-tab :request-object-key="requestObjectKey"></debtor-employees-tab>
        </v-tab-item>
      </v-tabs-items>
    </div>
  </div>
</template>
<script>

import PartnersTab from './partners-tab/index';
import BranchesTab from './branches-tab/index';
import BankruptDebtsTab from './bankrupt-debts-tab/index';
import DebtorAssetsTab from './debtor-assets-tab/index';
import BankruptDueRightsTab from './bankrupt-due-rights-tab/index';
import DebtorEmployeesTab from './debtor-employees-tab/index';

export default {
  name: 'RequestDetails',
  components: {
    PartnersTab,
    BranchesTab,
    BankruptDebtsTab,
    DebtorAssetsTab,
    BankruptDueRightsTab,
    DebtorEmployeesTab,
  },
  props: {
    requestObjectKey: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      tab: null,
      basicInfoLocal: this.local.bankruptcy.bankruptcyFile,
    };
  },
  computed: {
    tabs() {
      return [
        {
          href: '#tab-1',
          title: this.local.bankruptcy.requestDetails.partners.tabTitle,
          disabled: false,
        },
        {
          href: '#tab-2',
          title: this.local.bankruptcy.requestDetails.branches.tabTitle,
          disabled: false,
        },
        {
          href: '#tab-3',
          title: this.local.bankruptcy.requestDetails.bankruptDebts.tabTitle,
          disabled: false,
        },
        {
          href: '#tab-4',
          title: this.local.bankruptcy.requestDetails.bankruptDueRights.tabTitle,
          disabled: false,
        },
        {
          href: '#tab-5',
          title: this.local.bankruptcy.requestDetails.debtorAssets.tabTitle,
          disabled: false,
        },
        {
          href: '#tab-6',
          title: this.local.bankruptcy.requestDetails.debtorEmployees.tabTitle,
          disabled: false,
        },
      ];
    },
  },
  watch: {},
  mounted() {
  },
  methods: {},
};

</script>

<style lang="scss" scoped>
    .tab-active {
        text-decoration: underline;
        color: var(--app-primary-color) !important;
        font-weight: bold;
        text-decoration: underline solid #009587 7px;
    }
</style>
